export default function Logo({ className = "", invert = false }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="fynix-logo">
      <img
        src="/fynix-logo.png"
        alt="Fynix Systems"
        width="36"
        height="36"
        className="h-9 w-9 rounded-sm object-contain"
        style={{ backgroundColor: "#000" }}
      />
      <div className="leading-none">
        <div
          className="font-display font-bold tracking-tight text-[15px]"
          style={{ color: invert ? "#FAFAFA" : "#0A0A0A" }}
        >
          Fynix <span className="font-normal opacity-70">Systems</span>
        </div>
        <div className="font-mono text-[9px] uppercase tracking-[0.22em] mt-0.5" style={{ color: "#EA580C" }}>
          Bottleneck · Fixed
        </div>
      </div>
    </div>
  );
}
